import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { tabularPropertiesCommonAdapts, TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';
import { DB2Dataset } from 'app/model/dataset/db2.dataset';
import { Metamodel } from 'app/model/base/model';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DB2Dataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            connectionProperties: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                tableName: '*',
                schema: '*',
                table: '*'
            }
        }
    }
})
export class DB2DatasetAdapter extends TabularTypeDatasetAdapter<DB2Dataset, Model.DatasetResource> {
}
